import { Controller } from "@hotwired/stimulus"

// Shows a field ONLY when a <select> (or radio group) has a matching value, so
// effect/style-specific controls appear in context instead of always being
// present with a "(used when …)" caption.
//
// Markup:
//   <div data-controller="conditional-fields">
//     <select data-conditional-fields-target="trigger"
//             data-action="change->conditional-fields#update">…</select>
//     <div data-conditional-fields-target="field"
//          data-conditional-fields-show-for="custom_path">…</div>
//     <div data-conditional-fields-target="field"
//          data-conditional-fields-show-for="arc circle">…</div>  <!-- space-separated -->
//   </div>
//
// Fields are HIDDEN (not removed), so their values survive switching back and
// forth without re-typing.
export default class extends Controller {
  static targets = ["trigger", "field"]

  connect() {
    this.update()
  }

  update() {
    const value = this.currentValue()
    this.fieldTargets.forEach((field) => {
      const forValues = (field.dataset.conditionalFieldsShowFor || "").split(/\s+/).filter(Boolean)
      field.hidden = !forValues.includes(value)
    })
  }

  // The trigger's value — a <select>/<input>, or the checked radio in a group.
  currentValue() {
    if (!this.hasTriggerTarget) return ""
    const checked = this.triggerTargets.find((t) => t.type === "radio" && t.checked)
    if (checked) return checked.value
    return this.triggerTarget.value
  }
}
